import { type FC, useMemo } from "react";

import { MetricChangeBadge } from "./MetricChangeBadge";

interface MetricDiffProps {
    diffValue: string;
}

export const MetricDiff: FC<MetricDiffProps> = ({ diffValue }) => {
    const isPositive = useMemo(() => diffValue.startsWith("+"), [diffValue]);
    const diffValueWithoutSign = useMemo(() => diffValue.replace("+", "").replace("-", ""), [diffValue]);

    if (diffValue === "N/A") {
        return <MetricChangeBadge value={diffValueWithoutSign} tone="neutral" />;
    }

    return (
        <MetricChangeBadge
            value={diffValueWithoutSign}
            tone={isPositive ? "positive" : "negative"}
            sign={isPositive ? "positive" : "negative"}
        />
    );
};
